<template>
    <div class="container list-surat">
        <h6>Surah</h6>
        <input id='query' type='text' v-model='search' placeholder="Telusuri"/>
        <div class="cover-ayat mt-5 mb-5">
            <div class="isi-list" v-for="result in filterData" v-bind:key="result.nomor">
                <div id='nomor'>
                    {{ result.nomor }}
                </div>
                <div id='nama-ayat'>
                    <router-link class='link-surat' v-bind:to='"baca/" + result.nomor + "/" + result.nama + "/" + result.arti '>
                    <span>{{ result.nama }}</span>
                    <span id='arti-ayat'>{{ result.arti }}</span>
                    </router-link>
                </div>
                <div id='nama-arab'>
                    <router-link class='link-surat' v-bind:to='"baca/" + result.nomor  + "/" + result.nama + "/" + result.arti'>
                    <span>{{ result.asma }}</span>
                    </router-link>
                </div>
                <div id='perbedaan'>
                    <router-link class='link-surat' v-bind:to='"baca/" + result.nomor   + "/" + result.nama + "/" + result.arti'>
                    <i v-if="result.type === 'mekah'" class='fa fa-kaaba'></i>
                    <i v-else class="fas fa-mosque"></i>
                    <span>{{ result.type }}</span>
                    </router-link>
                </div>
            </div>

        </div>
    </div>
</template>
<style>
    #query 
    {
        width: 33.4%;
        padding: 0% 2% 0% 2%;
        height: 40px;
        border: 1px solid #dfd3d3;
        border-radius: 5px;
        margin-top: 2%;
    }
    #query:focus{
        outline: none;
    }
    @media screen and (max-width: 780px)
    {
        #query 
        {
            width: 45%;
        }
    }
    .list-surat 
    {
        width: 100%;
        height: auto;
        margin-top: 5%;
    }
    .cover-ayat 
    {
        width: 100%;
        height: auto;
        display: grid;
        grid-template-columns: auto auto auto;
        grid-column-gap: 30px;
        grid-row-gap: 30px;
    }
    .isi-list 
    {
        width: 100%;
        height: auto;
        padding: 4% 3% 4% 3%;
        display: flex;
        border: 1px solid #dfd3d3;
        border-radius: 5px;
        align-items: center;
        transition: 0.3s;
    }
    .isi-list:hover{
        box-shadow: 0px 5px 20px 1px rgba(0,0,0,0.1);
        border: 1px solid transparent;
    }
    #nomor 
    {
        width: 10%;
    }
    #nama-ayat 
    {
        width: 30%;
        padding: 0% 0% 0% 2%;
    }
    #nama-ayat span 
    {
        display: block;
    }
    #arti-ayat 
    {
        font-size: 11px;
    }
    #nama-arab 
    {
        width: 35%;
        font-size: 25px;
        text-align: center;
    }
    #perbedaan 
    {
        width: 25%;
        text-align: center;
    }
    #perbedaan span 
    {
        display: block;
        font-size: 11px;
    }
    .link-surat 
    {
        color: #756060;
        text-decoration: none;
    }
    .link-surat:hover{
        text-decoration: none;
        color: #756060;
    }
    .link-surat:focus{
        outline: none;
    }
    @media screen and (max-width: 780px){
        .cover-ayat
        {
            grid-template-columns: auto auto;
            margin-bottom: 20%;
            grid-column-gap: 20px;
            grid-row-gap: 20px;
        }
        #nama-arab 
        {
            display: none;
        }
        #nama-ayat
        {
            width: 50%;
        }
        .isi-list
        {
            justify-content: space-around;
            width: 100%;
        }
        .list-surat
        {
            margin-bottom: 50%;
        }
        #nomor 
        {
            font-size: 11px;
        }
    }
</style>
<script>
import axios from 'axios';


export default {
    data(){
        return {
            proxy: 'https://cors-anywhere.herokuapp.com/',
            url: 'https://al-quran-8d642.firebaseio.com/data.json?print=pretty',
            data: [],
            search: '',
        }
    },
    created(){
        axios.get(`${this.proxy}${this.url}`)
        .then((res) => {
            this.data = res.data;
        })
    },
    computed: {
        filterData: function(){
            return this.data.filter((konten) => {
                var upper = this.search.replace(/\w\S*/g, function (word) {
                    return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
                    });
                return konten.nama.match(upper);
            });
        }
    }
}
</script>